<template>
  <div class='post-comment'>
    <Head title="意见反馈"></Head>
    <div class='post-comment-content'>
      <a-form :form="form" @submit="handleSubmit">
        <a-form-item label="反馈模块" v-bind="formItemLayout">
          <a-select allowClear showSearch placeholder="请选择对应模块" :filterOption="filterOption" v-decorator="[
          'category_id',
          { initialValue: defaultValue, rules: [{ required: true, message: '请选择对应模块!' }] },
        ]" style="width: 300px">
            <a-select-option
              v-for="(option, index) in options"
              :key="index"
              :value="index+1"
            >{{option.name}}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="建议内容" v-bind="formItemLayout">
          <a-textarea
            :rows="6" placeholder='请简明描述您的问题'
            v-decorator="[
              'content',
              {
                rules: [{ required: true, message: '请简明描述您的问题!' }]
              }
          ]"/>
        </a-form-item>
        <a-form-item label="上传附件" v-bind="formItemLayout">
          <b-img-upload v-decorator="[
            'img_url',
            {
              initialValue: [],
              rule: [
              ]
            }
          ]"></b-img-upload>
        </a-form-item>
        <a-form-item label='电话号码' v-bind="formItemLayout">
          <a-input placeholder='请留下您的联系方式，方便后期问题解决' :maxLength="11" v-decorator="['mobile_phone', { rules: [{ required: true, message: '请留下您的联系方式，方便后期问题解决!' },{ pattern: new RegExp(/^1\d{10}$/, 'g'), message: '请输入正确格式的手机号' }] }]"/>
        </a-form-item>
        <a-form-item label='QQ号码' v-bind="formItemLayout">
          <a-input placeholder='请留下您的联系方式，方便后期问题解决' :maxLength="15" v-decorator="['qq', { rules: [{ required: true, message: '请留下您的联系方式，方便后期问题解决!' },{ pattern: new RegExp(/^([1-9]\d*)$/, 'g'), message: '请输入正确格式的QQ号码' }] }]"/>
        </a-form-item>
        <a-form-item :wrapper-col="{ offset:3, span: 18 }">
          <a-button class="btn" type="primary" html-type="submit" :disabled="disable">提交</a-button>
        </a-form-item>
      </a-form>
    </div>
  </div>
</template>
<script>
import { Form, Input, Modal, Button, Select, InputNumber } from 'ant-design-vue'
import { cookies } from '@utils'
import Head from '@components/title/newIndex'
import BImgUpload from "@components/upload";
import SuggestionCateSelector from "./suggestion-cate-selector";
import SubmitCommitParam from "./SubmitCommitParam";
import {jump} from '@utils'
const { Item } = Form
const { TextArea } = Input
const { Option } = Select
export default {
  components: {
    Head,
    BImgUpload,
    SuggestionCateSelector,
    [Modal.name]: Modal,
    [Form.name]: Form,
    [Item.name]: Item,
    [Input.name]: Input,
    [TextArea.name]: TextArea,
    [Button.name]: Button,
    [Select.name]: Select,
    [Option.name]: Option,
    [InputNumber.name]: InputNumber
  },
  data() {
    return {
      formItemLayout: {
          labelCol: {
              xs: { span: 24 },
              sm: { span: 3 },
          },
          wrapperCol: {
              xs: { span: 24 },
              sm: { span: 16 },
          },
      },
      options: [],
      form: this.$form.createForm(this),
      defaultValue: undefined,
      disable: false,
    }
  },
  async created() {
    const query = this.$route.query
    const origin = query.origin || ''
    if (origin === 'home') {
      this.options = [{ name: '首页'}]
      this.defaultValue = 1
    } else {
      const originMenu = await this.$store.dispatch('comment/getMenus')
      if (originMenu.code === 0) {
        this.options = this.buildMenu(originMenu)
      } else if (originMenu.code === 1024) {
        jump.login()
      } else {
        this.$message.error(`获取菜单接口错误：${originMenu.message}`)
      }
    }
  },
  methods: {
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    buildMenu(menus) {
      const result = []
      this.buildMenuRe(menus.data, result)
      return result
    },

    buildMenuRe(dd = [], result) {
      for(const sd of dd) {
        if (sd.children && sd.children.length > 0) {
          this.buildMenuRe(sd.children, result)
        } else {
          result.push({name: sd.info.title})
        }
      }
    },
    handleSubmit (e) {
      e.preventDefault();
      this.form.validateFields(async (error, values) => {
        if (!error) {
          this.disable = true
          const category = this.options[values.category_id-1]
          values.category_name = category.name
          // 2022-04-24 安全修复，siteToken服务端设置为http-only，js读不到， 改用siteUserId判断
          // values.anonymous_switch = !cookies.get('siteToken')
          values.anonymous_switch = !cookies.get('siteUserId')
          // console.log(values)
          const { code, message } = await this.$store.dispatch('comment/submitCommit',{ ...new SubmitCommitParam(values) })
          if (code * 1 === 1001) {
            this.$message.success('提交成功！', 2, () => {
              const query = this.$route.query
              const origin = query.origin || ''
              // 2022-04-24 安全修复，siteToken服务端设置为http-only，js读不到， 改用siteUserId判断
              // cookies.get('siteToken') && (location.href = `/pages/comment/result?origin=${origin}`)
              cookies.get('siteUserId') && (location.href = `/pages/comment/result?origin=${origin}`)
            })
          } else if (code * 1 === 1005) {
            this.disable = false
            //未登录
            jump.login()
          } else {
            this.disable = false
            this.$message.error(message)
          }
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.post-comment{
  background-color: #fff;
  height:100%;
  .post-comment-content{
    padding-top: 20px;
    padding-bottom: 1px;
  }

  .btn{
    width: 120px;
    margin-right: 20px;
    height: 44px;
    font-size: 16px;
  }
}
</style>
